export default __webpack_public_path__ + "static/media/marketplace-white.eccdc779.svg";